import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { ActionButtons, FormGrid, FormikForm } from "../../../../../forms";
import templateFields from "./templateFields";
import BWModels from "@benjamin-west-rpm2/benjamin-west-models";

const getValidationSchema = () => BWModels.loadSchema("TemplateCategory");

export default class CreateTemplateCategoryForm extends Component {
  handleSubmit = (values, actions) => {
    const { onSubmit } = this.props;

    onSubmit(values, actions);
  };

  render() {
    const { dataComponentId, isSuperAdmin, isEditing } = this.props;

    return (
      <FormikForm
        initialValues={this.props.initialValues}
        onSubmit={this.handleSubmit}
        validationSchema={getValidationSchema()}
        ignoreValidationFieldNames={["scopeId"]}
      >
        {({ handleSubmit, ...formikProps }) => (
          <Fragment>
            <FormGrid
              fields={templateFields(isSuperAdmin, isEditing)}
              {...formikProps}
            />

            <ActionButtons
              sendButtonText={this.props.isEditing ? "Save" : "Create"}
              onSend={handleSubmit}
              isModal={true}
              listeners={[dataComponentId]}
            />
          </Fragment>
        )}
      </FormikForm>
    );
  }
}

CreateTemplateCategoryForm.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  isEditing: PropTypes.bool,
  isSuperAdmin: PropTypes.bool,
  dataComponentId: PropTypes.string.isRequired,
};
